import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/user/importer/userImporterActions'

export default importerReducers(actions)
